<template>
  <div>
    <b-table
      striped
      hover
      show-empty
      id="corrective-actions-results"
      class="corrective-actions-results"
      :fields="fields"
      :items="entities"
      ref="table"
    >
      <template #empty="scope">
        <div class="chemtracker-empty-text">
          No corrective actions have been defined yet.
        </div>
      </template>
      <template #cell(field_inc_invest_action_complete)="row">
        <input
          type="checkbox"
          :name="'action-name-' + row.index"
          :id="'action-name-' + row.index"
          :value="row.item.id"
          :data-entity-uuid="row.item.id"
          v-model="selectedActionItem"
          @change="updateCompletedStatus($event)"
          :disabled="disabled"
        />
      </template>
    </b-table>
    <b-button @click="showDialog" v-if="!disabled">
      Add Corrective/Preventative Action
    </b-button>
    <b-modal
      id="add-corrective-action"
      centered
      scrollable
      title="Add Corrective/Preventative Actions"
      size="lg"
      hide-footer
    >
      <div class="lg-modal-body-padded">
        <add-metadata-entity
          :add-class="addClass"
          association-bundle="incident_investigation"
          :association-uuid="investigationUuid"
          metadata-type="incident_correct_prevent_action"
          @submit-form-data="handleAddAction($event)"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
import AddMetadataEntity from "../metadata_entities/AddMetadataEntity.vue";
import { jsonClient } from "../../lib/raftApi";

export default {
  name: "CorrectiveActionsListing",
  data() {
    return {
      addClass: "fullWidth",
      fields: [
        { key: "field_inc_invest_action_text", label: "Action" },
        { key: "field_inc_invest_action_resp_ent", label: "Responsible Party" },
        { key: "field_inc_invest_action_complete", label: "Completed" },
      ],
      entities: [],
      selectedActionItem: [],
    };
  },
  props: {
    investigationUuid: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    AddMetadataEntity,
  },
  methods: {
    showDialog: function () {
      this.$bvModal.show("add-corrective-action");
    },
    hideDialog: function () {
      this.$bvModal.hide("add-corrective-action");
    },
    handleAddAction: function () {
      this.hideDialog();
      this.fetchCorrectiveActions();
    },
    fetchCorrectiveActions: async function () {
      const queries = {
        "filter[status][condition][path]": "status",
        "filter[status][condition][value]": 1,
        "filter[active][condition][path]": "operative_status",
        "filter[active][condition][value]": 1,
        "filter[parent][condition][path]": "association.id",
        "filter[parent][condition][value]": this.investigationUuid,
      };
      const options = {
        path: "/raft_metadata/incident_correct_prevent_action",
        queries: queries,
      };
      const response = await jsonClient
        .get(options)
        .catch((e) => console.dir(e));
      this.entities = response.deserialized;
      this.entities.forEach((entity) => {
        if (entity.field_inc_invest_action_complete) {
          this.selectedActionItem.push(entity.id);
        }
      });
    },
    updateCompletedStatus: async function (event) {
      const data = {
        id: event.target._value,
        type: "raft_metadata--incident_correct_prevent_action",
        attributes: {},
      };
      data.attributes.field_inc_invest_action_complete =
        this.selectedActionItem.indexOf(event.target._value) !== -1 ? 1 : 0;
      const options = {
        path:
          "/raft_metadata/incident_correct_prevent_action/" +
          event.target._value,
        queries: {},
        data,
      };
      await jsonClient.patch(options).catch((e) => console.error(e));
    },
  },
  async created() {
    await this.fetchCorrectiveActions();
  },
};
</script>

<style scoped>
.lg-modal-body-padded {
  padding: 2px 6px 6px 6px;
}
</style>
